module.exports = __webpack_public_path__ + "static/1-b24b67d78ea76d65aed74a9032831cfd.jpeg";